Librarian.ShareOnLinkedInWindow = new Class({
    Extends: Librarian.Window, 
    Binds: ["onWindowLoaded", "onSubmitClicked", "authenticateAndShare", "watchChildWindow", "openWindowCentered"], 

    options: {
        /* Window Params */
        id: "ShareOnLinkedInWindow",
        title: "Share File on LinkedIn",
        height: 270, 
        width: 450, 
        type: 'modal',

        /* LinkedIn API Params */
        clientId: "86q7qihzfkj1kt", 
        auth_type: "linkedin", 
        authEndpoint: "https://www.linkedin.com/oauth/v2/authorization?",
        shareStatusCookieName: "linkedin_share_status",

        downloadUrl: null,
        thumbnailUrl: null,
        filename: null, 
        comment: null, 
        linkedinaudience: null
    }, 

    initialize: function(options) {
        this.setOptions(options);
        this.options.contentURL = Librarian.path.getLayoutsPath() + "core/shareonlinkedin/shareonlinkedin.html";
        this.parent(this.options);
    }, 

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        $("ShareOnLinkedInWindow_shareOnLinkedInFilename").set("text", this.options.filename);
        $("ShareOnLinkedInWindow_shareOnLinkedInSubmit").addEvent("click", this.onSubmitClicked);
    },

    onSubmitClicked: function() {
        // get input forms values
        this.options.comment = $("ShareOnLinkedInWindow_shareOnLinkedInComment").get("value");
        this.options.linkedinaudience = $$("input[name=linkedinaudience]:checked")[0].value;

        // validate input form values
        if(!(this.options.comment && this.options.linkedinaudience)) {
            return;
        }
        else if(!(this.options.linkedinaudience === "anyone" || this.options.linkedinaudience === "connections-only")) {
            return;
        } 

        // authenticate linkedIn
        this.authenticateAndShare();
    },

    authenticateAndShare: function() {

        var state = {
            type: this.options.auth_type,
            library: Librarian.sessionInfo.ShortName, 
            clientId: this.options.clientId, 
            origin: window.location.hostname,
            shareStatusCookieName: this.options.shareStatusCookieName,

            // file share parameters
            comment: this.options.comment,
            title: this.options.filename,
            submittedUrl: this.options.downloadUrl,
            submittedImageUrl: this.options.thumbnailUrl,
            audience: this.options.linkedinaudience
        };

        this.startLoadingPhase();

        // encode json object to pass in query string
        state = this.encodeStateParameter(state);

        // launch linkedin auth window
        var redirectUri = "https://" + window.location.hostname + "/webclient/apps/oauth2redirect/oauth2redirect.htm";
        var authPageUrl = this.options.authEndpoint + "response_type=code" + "&client_id=" + this.options.clientId + "&redirect_uri=" + redirectUri + "&state=" + state; 
        var childWindow = this.openWindowCentered(authPageUrl, "LinkedIn Authentication", 600, 600);

        // wait for childwindow to close, access token cookie should be set
        this.watchChildWindow(childWindow);

    }, 

    watchChildWindow: function(childWindow) {
        var self = this;

        var watcher = setInterval(function() {
            if(childWindow.closed) {
                clearInterval(watcher);
                self.endLoadingPhase();

                // get share status from redirectURI
                var shareStatus = Cookie.read(self.options.shareStatusCookieName);
                Cookie.dispose(self.options.shareStatusCookieName);

                if(shareStatus && shareStatus === "success") {
                    // share succeded
                    Librarian.Utils.notification("Share Successful", false);
                    self.close();
                } else {
                    // share failed
                    Librarian.Utils.error("Share Failed");
                }

            }
        }, 500);

    },


    /* Utils */

    encodeStateParameter: function(state) {
        return encodeURIComponent(Base64.encode(JSON.stringify(state)));
    }, 

    openWindowCentered: function(url, title, w, h) {
        var left = ((screen.width / 2) - (w / 2));
        var top = ((screen.height / 2) - (h / 2));
        return window.open(url, title, 'scrollbars=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    }, 

    startLoadingPhase: function() {
        $("ShareOnLinkedInWindow_shareOnLinkedInOverlay").show();
        $("ShareOnLinkedInWindow_shareOnLinkedInLoadingImage").show();
    }, 

    endLoadingPhase: function() {
        $("ShareOnLinkedInWindow_shareOnLinkedInOverlay").hide();
        $("ShareOnLinkedInWindow_shareOnLinkedInLoadingImage").hide();
    }

});